import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Icon from 'src/common/components/IconDS22';
import SnoozeToggle from 'src/admin/common/components/SnoozeModal/SnoozeToggle';
import styles from './SnoozeBulkListings.module.scss';

export type SnoozeBulkListingsProps = {
  totalListings: number;
  checked: boolean;
  handleToggle: () => void;
  handleClick: () => void;
};

const SnoozeBulkListings: FC<SnoozeBulkListingsProps> = ({
  totalListings,
  checked,
  handleToggle,
  handleClick,
}) => {
  const [t] = useTranslation('admin-listings');
  return (
    <SnoozeToggle
      checked={checked}
      handleToggle={handleToggle}
      variant="bulk"
    >
      <button
        type="button"
        onClick={handleClick}
        className={styles.button}
      >
        <div className={styles.title}>
          <Icon id="listings" size="l" />
          {t('snooze-listing--bulk-select-title')}
          <span className={styles.count}>
            {t('snooze-listing--bulk-select-count', { count: totalListings })}
          </span>
        </div>
        <Icon id="caret-right" size="l" />
      </button>
    </SnoozeToggle>
  );
};

export default SnoozeBulkListings;
